/**
 *
 * @param {number} bytes
 * @param {boolean} si
 * @return {string}
 */
export function humanFileSize(bytes, si = true) {
  const threshold = si ? 1000 : 1024;

  if (Math.abs(bytes) < threshold) {
    return bytes + ' B';
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

  let u = -1;

  while (Math.abs(bytes) >= threshold && u < units.length - 1) {
    bytes /= threshold;
    ++u;
  }

  return bytes.toFixed(1) + ' ' + units[u];
}
